import { getCookie, transformQueryToDict } from './cookie_utils';

export function analyticsLoad(silent=true) {
    try {
        const url = window.location.href;
        const devEnvironments = ['127.0.0.1', 'localhost', 'corpweb-sandbox'];
        const isDev = devEnvironments.some((env) => url.includes(env));

        const hightouchDevId = "e01e47fc32edd55108ee05694c0bfe239f932642874496328151863e57af0805";
        const hightouchProdId = "2cddec53fd867c6fbb7557febb16f8ef032a53950f6e7c2381659e1d846dc38e";
        const hightouchId = isDev ? hightouchDevId : hightouchProdId;

        // Initialize Hightouch analytics
        const htevents = HtEventsBrowser.load({ writeKey: hightouchId }, { apiHost: "us-east-1.hightouch-events.com" });

        const mixpanelCookie = getCookie("mp_81f04dbeb4db7ff80420f5b348506aa7_mixpanel");
        if (mixpanelCookie) {
            const loadedMixpanelCookie = JSON.parse(mixpanelCookie);
            const mixpanelDistinctId = loadedMixpanelCookie["distinct_id"]
            if(mixpanelDistinctId) {
                htevents.setAnonymousId(mixpanelDistinctId);
            }
        }
        analyticsPage();
    } catch(e) {
        if (!silent) console.error(e);
    }
}

export function analyticsTrack(eventName, customProperties={}, silent=true) {
    try {
        const baseProperties = {
            is_mobile: isMobile(),
            app: 'corpweb'
        }
        const properties = {...baseProperties, ...customProperties}

        htevents.track(eventName, properties);
    } catch(e) {
        if (!silent) console.error(e);
    }
}

export function analyticsPage(customProperties={}, silent=true) {
    try {
        const queryParameters = transformQueryToDict();

        const baseProperties = {
            cid: queryParameters['cid'] || '',
            gclid: queryParameters['gclid'] || '',
            keyword: queryParameters['keyword'] || '',
            msclkid: queryParameters['msclkid'] || '',
            utm_ext_ad_id: queryParameters['utm_ext_ad_id'] || '',
            utm_ext_adset_id: queryParameters['utm_ext_adset_id'] || '',
            utm_ext_campaign_id: queryParameters['utm_ext_campaign_id'] || '',
            is_mobile: isMobile(),
            app: 'corpweb',
        }

        const properties = {...baseProperties, ...customProperties}

        htevents.page(properties);
        htevents.track('page viewed', {...properties, ...{
            'page name' : document.title,
            'url' : window.location.pathname
        }});
    } catch(e) {
        if (!silent) console.error(e);
    }
}

export function analyticsIdentify(identifier, properties={}, silent=true) {
    try {
        htevents.identify(identifier, properties);
    } catch(e) {
        if (!silent) console.error(e);
    }
}

export function analyticsAlias(identifier, properties={}, silent=true) {
    try {
        htevents.alias(identifier, properties);
    } catch(e) {
        if (!silent) console.error(e);
    }
}

export function analyticsTrackRetry(eventName, customProperties={}, maxAttempts=10, silent=true) {
    try {
        // Wait for analytics to be defined before tracking first step to avoid race
        // condition. This code does not block the main thread. The attempt logic is
        // to prevent this code from running perpetually if analytics will never be
        // defined like when someone has an adblocker.
        (async() => {
            let attempts = 0;
            while((typeof htevents === 'undefined') && attempts < maxAttempts) {
              attempts += 1;
              await new Promise(resolve => setTimeout(resolve, 500));
            }
            if (attempts <= maxAttempts) {
                analyticsTrack(eventName, customProperties);
            }
        })();
    } catch(e) {
        if (!silent) console.error(e);
    }
}

export function isMobile() {
    if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
        || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4)))
    {
        return true;
    } else {
        return false;
    }
}

export function getHightouchId(silent=true) {
  try {
        return htevents.user().id() || htevents.user().anonymousId();

    } catch(e) {
        if (!silent) console.error(e);
        return '';
    }
}

export function analyticsUserTraitsIdentified(...traits) {
    try {
        const identified_traits = htevents.user().traits();

        for (let i = 0; i < traits.length; i++) {
            let hasTrait = traits[i] in identified_traits;
            if (!hasTrait) {
                return false;
            }
        }

        return true;
    } catch (e) {
        return false;
    }
}

